var childrenList = new Array();
// 系统登录页面路由
import commen from '../view/common/_router'
pushArray(childrenList, commen.index)

//系统配置路由
import sys from '../view/sys/_router'
pushArray(childrenList, sys.index)

// 明细管理路由
import BillSchedule from '../view/BillSchedule/_router'
pushArray(childrenList, BillSchedule.index)

// 企业管理路由
import qymanage from '../view/qymanage/_router'
pushArray(childrenList, qymanage.index)

// 外部企业路由
import qccmanager from '../view/qccmanager/_router'
pushArray(childrenList, qccmanager.index)

// 外部企业路由
import qccplan from '../view/qccplan/_router'
pushArray(childrenList, qccplan.index)

// 我分配的企业
import myqccmanager from '../view/myqccmanager/_router'
pushArray(childrenList, myqccmanager.index)

//项目分组路由
import egroup from '../view/egroup/_router'
pushArray(childrenList, egroup.index)

// 库存管理路由
import InventoryFrom from './InventoryForm/_router'
pushArray(childrenList, InventoryFrom.index)

//员工信息路由
import gzuser from './gzuser/_router'
pushArray(childrenList, gzuser.index)

//工资相信信息路由
import gzdetils from './gzdetils/_router'
pushArray(childrenList, gzdetils.index)

// 发票管理路由
import InvoiceForm from '../view/InvoiceForm/_router'
pushArray(childrenList, InvoiceForm.index)

//分类科目路由
import type from '../view/type/_router'
pushArray(childrenList, type.index)

//deepseekAI路由
import deepseek from '../view/deepseek/_router'
pushArray(childrenList, deepseek.index)

//企业套餐路由
import qysetmeal from '../view/qysetmeal/_router'
pushArray(childrenList, qysetmeal.index)

//企业会计路由
import qykjuser from '../view/qykjuser/_router'
pushArray(childrenList, qykjuser.index)

//企业申报记录
import qy_gssb from '../view/qy_gssb/_router'
pushArray(childrenList, qy_gssb.index)

//人员班组信息
import user_bz from '../view/user_bz/_router'
pushArray(childrenList, user_bz.index)

//人员班组项目信息
import user_bzxm from '../view/user_bzxm/_router'
pushArray(childrenList, user_bzxm.index)

//企业业务信息
import qyservice from '../view/qyservice/_router'
pushArray(childrenList, qyservice.index)

//提现记录
import zkpttgytcplan from '../view/zkpttgytcplan/_router'
pushArray(childrenList, zkpttgytcplan.index)

//企业任务信息
import qy_task from '../view/qy_task/_router'
pushArray(childrenList, qy_task.index)

//企业任务信息
import qy_taskbz from '../view/qy_taskbz/_router'
pushArray(childrenList, qy_taskbz.index)

//保证金
import qy_bzj from '../view/qy_bzj/_router'
pushArray(childrenList, qy_bzj.index)

//普通推广人佣金
import zkpromoter_commission_configpt from '../view/zkpromoter_commission_configpt/_router'
pushArray(childrenList, zkpromoter_commission_configpt.index)

//会计保证金订单
import qy_bzjorder from '../view/qy_bzjorder/_router'
pushArray(childrenList, qy_bzjorder.index)

//套餐订单
import qytcorder from '../view/qytcorder/_router'
pushArray(childrenList, qytcorder.index)

//套餐订单
import qyzdplan from '../view/qyzdplan/_router'
pushArray(childrenList, qyzdplan.index)

//企业会计类型
import qykjtype from '../view/qykjtype/_router'
pushArray(childrenList, qykjtype.index)

//税务类型
import qysw from '../view/qysw/_router'
pushArray(childrenList, qysw.index)

//业务类型
import corporateservices from '../view/corporateservices/_router'
pushArray(childrenList, corporateservices.index)


//---------------------------------------------------------
//普通推广人
import zkpromoter_info from '../view/zkpromoter_info/_router'
pushArray(childrenList, zkpromoter_info.index)

//合伙推广人
import zkpartner_info from '../view/zkpartner_info/_router'
pushArray(childrenList, zkpartner_info.index)

//佣金比例
import zkpromoter_commission_config from '../view/zkpromoter_commission_config/_router'
pushArray(childrenList, zkpromoter_commission_config.index)

//推广记录
import zkpromoter_monthly from '../view/zkpromoter_monthly/_router'
pushArray(childrenList, zkpromoter_monthly.index)

//普通推广人年度分红奖金池表
import zkptfhjc from '../view/zkptfhjc/_router'
pushArray(childrenList, zkptfhjc.index)

//合伙推广人年度分红奖金池表
import zkhehuofhjc from '../view/zkhehuofhjc/_router'
pushArray(childrenList, zkhehuofhjc.index)

//产品信息
import zkproduct from '../view/zkproduct/_router'
pushArray(childrenList, zkproduct.index)

//权益分类
import zkequitycategory from '../view/zkequitycategory/_router'
pushArray(childrenList, zkequitycategory.index)

//权益明细
import zkequitydetail from '../view/zkequitydetail/_router'
pushArray(childrenList, zkequitydetail.index)

//权益明细
import zkpromoter_ladder_reward from '../view/zkpromoter_ladder_reward/_router'
pushArray(childrenList, zkpromoter_ladder_reward.index)

//合伙推广人排名奖励配置
import zkpartner_ranking_reward from '../view/zkpartner_ranking_reward/_router'
pushArray(childrenList, zkpartner_ranking_reward.index)

//合伙推广人年度排名记录表
import zkpartner_annual_ranking from '../view/zkpartner_annual_ranking/_router'
pushArray(childrenList, zkpartner_annual_ranking.index)

//订单信息
import zkorderinfo from '../view/zkorderinfo/_router'
pushArray(childrenList, zkorderinfo.index)

 export default {
    index: childrenList
}
function pushArray(obj1, obj2) {
    obj2.forEach(function (o) {
        obj1.push(o);
    })
}



// WEBPACK FOOTER //
// ./src/view/_router.js